// Jediný zdroj pravdy pro kontaktní údaje (telefon / email / mapa).
export const PHONE_DISPLAY = "+420 266 610 930";
export const PHONE_TEL = "+420266610930";
export const FAX_DISPLAY = "+420 266 610 927";
export const EMAIL = "info@marcsteel.cz";
export const EMAIL_SALES = "tomas.smrcka@marcsteel.cz";
export const MAPS_URL = "https://maps.app.goo.gl/dyJvK18NUVS1cVM38";
